import { DateInput } from "components/DesignSystem/DateInput/DateInput";
import { YYYY_MM_DD } from "constants/date";
import dayjs from "dayjs";
import { Field, FieldProps, Form, Formik } from "formik";
import { useToast } from "hooks/useToast";
import React from "react";
import { useUpdateTaskAssigneeAdminMutation } from "store/apis/serviceTeam";
import { BackendError } from "types/utils/error";

export const BookkeepingStartedOn = ({
  taskId,
  startedOn,
}: {
  taskId: string;
  startedOn: string | null;
}) => {
  const { successToast, alertToast } = useToast();
  const [updateTaskBookkeepingStartTime, { isLoading }] =
    useUpdateTaskAssigneeAdminMutation();

  const handleBookkeeperStartedOn = async (date: Date) => {
    try {
      const bookkeepingStartTime = dayjs(date).format(YYYY_MM_DD);
      if (taskId) {
        await updateTaskBookkeepingStartTime({
          bookkeeping_task_start_date: bookkeepingStartTime,
          taskId: taskId,
        }).unwrap();
        successToast({
          message: "Bookkeeping start date updated successfully!",
        });
      }
    } catch (error) {
      alertToast({
        message: (error as BackendError)?.data?.error?.message,
      });
    }
  };

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <Formik
        onSubmit={() => {}}
        initialValues={{ bookkeeperStartedOn: startedOn }}
      >
        {() => (
          <Form className="t-m-0">
            <Field name="bookkeeperStartedOn">
              {({ field }: FieldProps) => {
                return (
                  <DateInput
                    {...field}
                    portalId="bookkeeperStartedOnPortal"
                    onDateChange={(date) => {
                      handleBookkeeperStartedOn(date);
                    }}
                    defaultValue={startedOn || ""}
                  />
                );
              }}
            </Field>
          </Form>
        )}
      </Formik>
    </div>
  );
};
